import React, { useEffect, useState } from 'react';

interface Props {
  expiresAt: string; // ISO
  className?: string;
}

function fmt(n: number): string {
  return n.toString().padStart(2, '0');
}

export const AuctionCountdown: React.FC<Props> = ({ expiresAt, className }) => {
  const [now, setNow] = useState(() => Date.now());

  useEffect(() => {
    const id = window.setInterval(() => setNow(Date.now()), 1000);
    return () => window.clearInterval(id);
  }, []);

  const targetMs = new Date(expiresAt).getTime();
  const remaining = Math.max(0, targetMs - now);
  const totalSec = Math.floor(remaining / 1000);
  const days = Math.floor(totalSec / 86400);
  const hours = Math.floor((totalSec % 86400) / 3600);
  const minutes = Math.floor((totalSec % 3600) / 60);
  const seconds = totalSec % 60;

  return (
    <div className={`flex items-baseline gap-6 ${className ?? ''}`}>
      {days > 0 && (
        <div className="flex flex-col items-center">
          <span className="text-caption font-caption text-subtext-color">Days</span>
          <span className="text-heading-2 font-heading-2 text-default-font">{days}</span>
        </div>
      )}
      <div className="flex flex-col items-center">
        <span className="text-caption font-caption text-subtext-color">Hours</span>
        <span className="text-heading-2 font-heading-2 text-default-font">{fmt(hours)}</span>
      </div>
      <div className="flex flex-col items-center">
        <span className="text-caption font-caption text-subtext-color">Minutes</span>
        <span className="text-heading-2 font-heading-2 text-default-font">{fmt(minutes)}</span>
      </div>
      <div className="flex flex-col items-center">
        <span className="text-caption font-caption text-subtext-color">Seconds</span>
        <span className="text-heading-2 font-heading-2 text-default-font">{fmt(seconds)}</span>
      </div>
    </div>
  );
};
